import { useState } from 'react';

export const MAX_VISIBLE_ITEMS = 10;

// const { visibleItems, canToggle, showAll, toggleShowAll } = useShowAll(subscriptions);
export const useShowAll = <T>(items: T[]) => {
  const [showAll, setShowAll] = useState(false);
  const canToggle = items.length > MAX_VISIBLE_ITEMS;
  const visibleItems = showAll || !canToggle ? items : items.slice(0, MAX_VISIBLE_ITEMS);

  return {
    visibleItems,
    canToggle,
    showAll,
    toggleShowAll: () => setShowAll(previous => !previous),
  };
};
